import React, { useState, createRef, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { MessageDescriptorPropType } from '../../../../../prop-types/intl';

import { Button } from 'ui-components/components/button';
import { ButtonThemeService } from 'ui-components/services/button-theme-service';
import { Pill } from 'ui-components/components/pill';
import { noop } from 'ui-components/default-props/noop';

import { CHOOSE_IMPORT_DIALOGUE } from '../../constants/import-products';

import messages from '../messages';
import style from '../style.module.less';

const FileUploader = ({
  className = '',
  name,
  file = null,
  setFile,
  theme = 'dark',
  message = messages.defaultSelectFileButtonMessage,
  shouldOnlyDisplayFilename = false,
  setModalDialogue = noop,
}) => {
  const fileInputRef = createRef();
  const [hasFileError, setHasFileError] = useState(false);

  const removeFile = useCallback(() => {
    setFile(null);
    setModalDialogue(CHOOSE_IMPORT_DIALOGUE);
  }, [setFile, setModalDialogue]);
  const clickUploadFile = useCallback(() => {
    setHasFileError('');
    fileInputRef.current.click();
  }, [fileInputRef]);
  const handleFileUpload = useCallback(
    (e) => {
      const uploadedFile = e.target.files[0];
      const allowedExtensions = ['csv'];
      if (uploadedFile) {
        const splitFilename = uploadedFile.name.split('.');
        const fileExt = splitFilename[splitFilename.length - 1].toLowerCase();
        if (allowedExtensions.includes(fileExt)) {
          const fileUploadReader = new FileReader();
          fileUploadReader.onload = () => {
            setFile(uploadedFile);
          };
          return fileUploadReader.readAsText(uploadedFile);
        }
      }
      setHasFileError(true);
    },
    [setFile],
  );

  return (
    <div className={style['import-select-button']}>
      {(!file || (file && !shouldOnlyDisplayFilename)) && (
        <Button onClick={clickUploadFile} theme={theme}>
          <FormattedMessage {...message} />
        </Button>
      )}
      <input ref={fileInputRef} accept='.csv' id={name} name={name} onChange={handleFileUpload} type='file' />
      {file && (
        <div className={classnames(style['import-pill'], className)}>
          <Pill label={file.name} onRemove={removeFile} theme='in-progress' />
        </div>
      )}
      {hasFileError && (
        <span className={style['import-file-extension-error']}>
          <FormattedMessage {...messages.importModalCSVError} />
        </span>
      )}
    </div>
  );
};

FileUploader.propTypes = {
  className: PropTypes.string,
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  setFile: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(ButtonThemeService.getButtonThemes()),
  message: PropTypes.oneOfType([PropTypes.node, MessageDescriptorPropType]),
  shouldOnlyDisplayFilename: PropTypes.bool,
  setModalDialogue: PropTypes.func,
};

export default FileUploader;
